import { useContext } from "react";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { scheduleCrud } from "@/api/schedule";
import { Button } from "@/components/common/Button";
import { ModalAlert } from "@/components/common/modals";
import { useDepartmentRoute } from "@/hooks/common/use-department-route";
import { useModal } from "@/hooks/common/use-modal";
import { showToast } from "@/providers";
import { useUserStore } from "@/stores/use-user-store";
import { canCompleteSchedule } from "@/utils/features/schedule/permission";
import { getUserRoleByDepartment } from "@/utils/user-positions";

import { ScheduleActionsContext } from "../Provider";

export const ScheduleActionsComplete = () => {
  const { schedule } = useContext(ScheduleActionsContext);
  const { department } = useDepartmentRoute();
  const activeUser = useUserStore((state) => state.activeUser);
  const modal = useModal();
  const queryClient = useQueryClient();
  const activeRole = getUserRoleByDepartment(activeUser, department);

  const mutation = useMutation({
    mutationFn: () => scheduleCrud.complete(schedule.id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["schedule"], refetchType: "all" });
      modal.closeModal();
      showToast({ type: "success", title: "Atendimento concluído com sucesso!" });
    },
    onError: () =>
      showToast({
        type: "error",
        title: "Erro ao concluir atendimento",
        content: "Tente novamente em alguns instantes.",
      }),
  });

  if (!canCompleteSchedule(activeRole, schedule)) {
    return null;
  }

  return (
    <>
      <Button variant="primary" onClick={modal.openModal} full>
        Concluir atendimento
      </Button>
      <ModalAlert
        isOpen={modal.isModalOpen}
        onClose={mutation.isPending ? undefined : modal.closeModal}
        isOverlayCloseable={!mutation.isPending}
        cancelable
        title="Tem certeza que deseja concluir o atendimento do talento?"
        description="Ao confirmar, o talento terá seu agendamento concluído. Essa ação é reversível e poderá ser desfeita."
        actions={[
          {
            type: "submit",
            children: "Sim, concluir atendimento",
            variant: "primary",
            className: "whitespace-nowrap",
            isLoading: mutation.isPending,
            onClick: () => mutation.mutate(),
          },
        ]}
      />
    </>
  );
};
